import {
  // Backdrop,
  CircularProgress,
  Pagination,
  Typography,
} from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"
import useStyles from "./useStyles"
import CreateClient from "../CreateClient/CreateClient"
import FilterButton from "../../../components/FilterButton/FilterButton"
import FilterInput from "../../../components/FilterInput/FilterInput"
import Table from "./TableNavigable/TableNavigable"
import CloseIcon from "@mui/icons-material/Close"
import { useEffect, useState } from "react"
import BreadcrumbsComponent from "../../Declarations/Breadcrumbs/Breadcrumbs"
import { useDispatch, useSelector } from "react-redux"
import {
  deleteSearchClientNameValueSubscription,
  deleteSearchValueSubscription,
  getAllSubsDelegationVE,
  deleteSearchUserNameValueSubscription,
  getUniqueEmailsFromSubscriptionDelegations,
  getUniqueCustomerSuborganizationNames,
  setSearchEvStatus,
  getSubscriptionSuccess,
} from "../../../redux/actions/eventanilla"
import { getFirmsCustomer } from "../../../redux/actions/clients"
import { useNavigate } from "react-router-dom"
import FilterDate from "../../../components/FilterDate/FilterDate"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
} from "../../../redux/actions/app"
import CuitImporter from "../CuitImporter"

export default function LoadedClients() {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const dispatch = useDispatch()
  const [initialLoading, setInitialLoading] = useState(true)
  const subscriptionData = useSelector(
    (state) => state?.eventanilla?.suscribersDelegation?.data?.data || [],
  )
  const pagination = useSelector(
    (state) => state?.eventanilla?.suscribersDelegation?.pagination || [],
  )

  const subscription = useSelector((state) => state?.eventanilla)
  const navigate = useNavigate()
  const {
    searchValueCUITSubscription,
    searchClientNameSubscription,
    dateFilter,
    searchuserNameSubscription,
    searchEvStatus,
  } = useSelector((state) => state.eventanilla)
  const nameToSearch =
    searchClientNameSubscription && searchClientNameSubscription.length > 0
      ? searchClientNameSubscription[0]
      : null
  const userNameToSearch =
    searchuserNameSubscription && searchuserNameSubscription.length > 0
      ? searchuserNameSubscription[0]
      : null

  const loadData = async (page = 1) => {
    setLoading(true)
    try {
      const mapEvStatusToBoolean = (status) => {
        if (!status) return null
        const mapping = {
          "Cliente Adherido a e-ventanilla": "isServiceEnabled",
          "Cliente no adherido a e-ventanilla": "clientME",
          "Cliente con observaciones": "clientWithRemarks",
          "CUIT No cargado como cliente": "none",
        }
        return mapping[status]
      }
      await dispatch(
        getAllSubsDelegationVE(
          searchValueCUITSubscription || null,
          nameToSearch,
          dateFilter || null,
          null,
          page,
          10,
          true,
          userNameToSearch,
          mapEvStatusToBoolean(searchEvStatus),
        ),
      )
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error al aplicar el filtro."))
    } finally {
      setLoading(false)
      setInitialLoading(false)
    }
  }

  useEffect(() => {
    dispatch(getSubscriptionSuccess({ data: [], pagination: {} }))
  }, [])

  useEffect(() => {
    setLoading(true)
    loadData(1)
  }, [
    searchValueCUITSubscription,
    searchClientNameSubscription,
    dateFilter,
    searchuserNameSubscription,
    searchEvStatus,
  ])

  const deleteValueSearchEvStatus = async () => {
    dispatch(setSearchEvStatus(null))
  }

  const deleteValueSearch = async () => {
    dispatch(
      deleteSearchValueSubscription(subscription.searchValueCUITSubscription),
    )
  }

  const deleteValueSearchClientName = async (name) => {
    const newList = subscription.searchClientNameSubscription.filter(
      (clientName) => clientName !== name,
    )
    dispatch(
      deleteSearchClientNameValueSubscription(
        newList.length > 0 ? newList : null,
      ),
    )
  }

  const deleteValueSearchUserName = async (name) => {
    const newList = subscription.searchuserNameSubscription.filter(
      (userName) => userName !== name,
    )
    dispatch(
      deleteSearchUserNameValueSubscription(
        newList.length > 0 ? newList : null,
      ),
    )
  }

  const handleChangePage = (_, newPage) => {
    loadData(newPage)
  }

  const handleSubmitModal = async (formData) => {
    setLoading(true)
    setModalOpen(false)
    try {
      const cuitValue = formData.customerSuborganizationCuit

      await dispatch(getFirmsCustomer(cuitValue))
      navigate(`detalleCliente/${cuitValue}`, { state: formData })
      // setModalOpen(false)
    } catch (error) {
      console.error("Error al crear cliente:", error)
    }
  }
  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true)

      try {
        await Promise.all([
          // dispatch(getAllSubsDelegationVE()),
          dispatch(getUniqueCustomerSuborganizationNames()),
          dispatch(getUniqueEmailsFromSubscriptionDelegations()),
        ])
      } catch (error) {
        console.error("Error durante la carga inicial de datos:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchInitialData()
  }, [dispatch])

  const hasData = Array.isArray(subscriptionData) && subscriptionData.length > 0
  return (
    <div className={classes.root}>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          e-Ventanilla - CUITs aceptados en ARCA
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon style={{ color: "#00a78f", marginLeft: 10 }} />
        <Typography className={classes.subtitle}>
          En esta sección se pueden administrar los CUITs aceptados en ARCA que
          fueron delegados a Errepar para descargar sus comunicaciones.
        </Typography>
      </div>

      <div>
        <div className={classes.boxTableArca}>
          <div className={classes.boxSearchBarAlta}>
            <button className={classes.buttonsearch} onClick={handleOpenModal}>
              <b>Cargar CUIT</b>
            </button>
            <div
              style={{
                marginLeft: "20px",
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FilterButton searchType="subscription" />
            </div>
            <div
              style={{
                marginLeft: "20px",
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CuitImporter />
            </div>
          </div>
          <CreateClient
            open={modalOpen}
            onClose={handleCloseModal}
            onSubmit={handleSubmitModal}
          />
        </div>
      </div>
      <div className={classes.boxTable}>
        <div className={classes.boxSearchBar}>
          <FilterInput searchType="subscription" />
          <FilterDate />
          <FilterInput searchType="delegationAcceptationUser" />
          <FilterInput searchType="evStatus" />
        </div>
        <div>
          <div className={classes.containerSearchValueButton}>
            {subscription.searchValueCUITSubscription && (
              <button
                className={classes.buttonResetFilterCUIT}
                onClick={deleteValueSearch}
              >
                <Typography className={classes.typographyButton}>
                  {subscription.searchValueCUITSubscription}
                </Typography>
                <CloseIcon className={classes.closeIconButtonReset} />
              </button>
            )}
            {subscription.searchClientNameSubscription &&
              subscription.searchClientNameSubscription.map((name) => (
                <button
                  className={classes.buttonResetFilterClientName}
                  onClick={() => deleteValueSearchClientName(name)}
                  key={name}
                >
                  <Typography className={classes.typographyButton}>
                    {name}
                  </Typography>
                  <CloseIcon className={classes.closeIconButtonReset} />
                </button>
              ))}

            {subscription.searchuserNameSubscription &&
              subscription.searchuserNameSubscription.map((name) => (
                <button
                  className={classes.buttonResetFilterClientName}
                  onClick={() => deleteValueSearchUserName(name)}
                  key={name}
                >
                  <Typography className={classes.typographyButton}>
                    {name}
                  </Typography>
                  <CloseIcon className={classes.closeIconButtonReset} />
                </button>
              ))}
            {subscription.searchEvStatus && (
              <button
                className={classes.buttonResetFilterClientName}
                onClick={deleteValueSearchEvStatus}
              >
                <Typography className={classes.typographyButton}>
                  {subscription.searchEvStatus}
                </Typography>
                <CloseIcon className={classes.closeIconButtonReset} />
              </button>
            )}
          </div>
        </div>
        {loading || (initialLoading && !hasData) ? (
          <div
            style={{
              width: "100%",
              height: "calc(100vh - 16rem)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#00a78f",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        ) : hasData ? (
          <Table
            rows={Array.isArray(subscriptionData) ? subscriptionData : []}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "calc(100vh - 16rem)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#4B4952",
              fontSize: "1rem",
              fontWeight: "bold",
              flexDirection: "column",
            }}
          >
            No se encontraron resultados
          </div>
        )}
      </div>
      <div>
        {" "}
        {pagination && pagination.pageCount > 1 && (
          <Pagination
            count={pagination.pageCount}
            page={pagination.page}
            onChange={handleChangePage}
            sx={{
              mt: 1,
              mb: 2,
              display: "flex",
              justifyContent: "center",
              color: "#028B7E",
            }}
          />
        )}
      </div>
    </div>
  )
}
